import { render, staticRenderFns } from "./UserPasswordChangeTab.vue?vue&type=template&id=b971325c"
import script from "./UserPasswordChangeTab.vue?vue&type=script&lang=js"
export * from "./UserPasswordChangeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports